<template>
  <section class="section dashboard">
    <div class="row">
      <div class="col-lg-12">
        <draggable
            v-model="accountCards"
            item-key="id"
            tag="div"
            class="row"
            handle=".drag-handle"
            @end="emit('drag', accountCards)"
        >
          <template #item="{ element: acc }">
            <div class="col-xxl-4 col-md-6 mb-4">
              <div class="card info-card revenue-card w-100 h-100">

                <div class="filter d-flex align-items-center">
                    <span class="drag-handle me-2" style="cursor: grab;">
                      <i class="bi bi-grip-vertical"></i>
                    </span>
                  <ActionDropdown>
                    <li class="dropdown-header text-start">
                      <h6>Действия</h6>
                    </li>

                    <li>
                      <router-link
                          class="dropdown-item"
                          :to="{ name: 'Transactions', params: { accountId: acc.id } }"
                      >Транзакции</router-link>
                    </li>
                    <li>
                      <a
                          @click.prevent="onUpdate(acc)"
                          class="dropdown-item"
                          href="#"
                      >Изменить</a>
                    </li>
                    <li>
                      <a
                          @click.prevent="onDelete(acc)"
                          class="dropdown-item"
                          href="#"
                      >Удалить</a>
                    </li>
                  </ActionDropdown>
                </div>

                <div class="card-body">
                  <router-link
                      class="dropdown-item"
                      :to="{ name: 'Transactions', params: { accountId: acc.id } }"
                  >
                    <h5 class="card-title">{{ acc.name }}</h5>

                    <div class="d-flex align-items-center">
                      <div
                          class="card-icon rounded-circle d-flex align-items-center justify-content-center"
                          style="font-size: x-large; font-weight: bold"
                      >
                        {{ acc.currency }}
                      </div>
                      <div class="ps-3">
                        <h6>{{ acc.balanceFormatted }}</h6>
                      </div>
                    </div>
                  </router-link>
                </div>

              </div>
            </div>
          </template>
        </draggable>

        <div class="row">
          <div class="col-xxl-4 col-md-6 mb-4">
            <div
                class="card info-card add-card w-100 h-100 d-flex align-items-center justify-content-center"
                @click="emit('add')"
                style="cursor: pointer;"
            >
              <div class="text-center">
                <h5 class="card-title">
                  <i class="bi bi-plus-lg" style="font-size: 48px;"></i>
                  <br>
                  Добавить
                </h5>
              </div>
            </div>
          </div>

        </div>
      </div>
    </div>
  </section>
</template>

<script setup>
import { ref, watch, nextTick, onMounted, onUnmounted } from 'vue';
import draggable from 'vuedraggable';
import { getCurrencyFormatted } from "@/api/helpers";
import ActionDropdown from "@/components/ui/components/ActionDropdown.vue";

const props = defineProps({
  accounts: { type: Array, required: true }
});

const emit = defineEmits(['update', 'delete', 'add', 'drag']);

const accountCards = ref([]);

function buildAccountCards(accounts) {
  accountCards.value = (accounts ?? []).map(account => ({
    ...account,
    balanceFormatted: getCurrencyFormatted(account.balance, account.currency)
  }));
}

watch(
    () => props.accounts,
    (accounts) => {
      buildAccountCards(accounts);
    },
    { immediate: true }
);

function onUpdate(acc) {
  emit('update', acc);
}

function onDelete(acc) {
  emit('delete', acc);
}
</script>
